import Store from 'store';

let State = {
    getState(stateName, defaultValue = null) {
        const state = Store.getState();

        if (!stateName) {
            return state;
        }

        if (!state.hasOwnProperty(stateName)) {
            return defaultValue;
        }

        return state[stateName];
    },
};

export default State;
